import { useState, useContext, createContext } from "react";

export const SubmissionsProvider = ({ children }) => {
  const [formVersion, setFormVersion] = useState(null)
  const [formVersionItems, setFormVersionItems] = useState([])
  const [selectedDocuments, setSelectedDocuments] = useState([])

  return (
    <SubmissionsContext.Provider
      value={{
        formVersion,
        setFormVersion,
        formVersionItems,
        setFormVersionItems,
        selectedDocuments, 
        setSelectedDocuments
      }}>
      {children}
    </SubmissionsContext.Provider>
  )
}
const SubmissionsContext = createContext({});

const useSubmissions = () => {
  return useContext(SubmissionsContext);
}

export default useSubmissions;